import { memo, useCallback } from 'react';

import styled from '@emotion/styled';

import Link from 'next/link';

import NewIcon from '../../shared/components/icons/NewIcon';

import { Menu } from '../interfaces';
import { amplitudeService } from '../../shared/amplitude';
import {
  SelectMyKurlyBulkOrder,
  SelectMyKurlyCouponList,
  SelectMyKurlyFrequentlyQna,
  SelectMyKurlyNoticeList,
  SelectMyKurlyPersonalInquiryHistory,
  SelectMyKurlyPointHistory,
  SelectMyKurlyProductInquiryHistory,
  SelectMyKurlyReviewHistory,
} from '../../shared/amplitude/events/mypage';
import { SelectMyKurlyPickList } from '../../shared/amplitude/events';
import COLOR from '../../shared/constant/colorset';
import { SelectMyKurlyStyle } from '../../shared/amplitude/events/mykurly-style';

const Container = styled.div`
  position: absolute;
  right: 0;
  top: 34px;
  width: 113px;
  padding: 3px 9px;
  border: 1px solid ${COLOR.lightGray};
  background-color: ${COLOR.kurlyWhite};
`;

const LinkItem = styled.div`
  display: block;
  height: 24px;
  line-height: 24px;
  cursor: pointer;
  img {
    vertical-align: top;
    margin-top: 7px;
  }
`;

interface Props {
  className?: string;
  menus: Menu[];
}

function SubMenu({
  className,
  menus,
}: Props) {

  const handleSubMenuLink = useCallback((title: string) => {
    switch (title) {
      case '찜한 상품':
        void amplitudeService.logEvent(new SelectMyKurlyPickList({ selectionType: 'dropdown' }));
        break;
      case '상품 후기':
        void amplitudeService.logEvent(new SelectMyKurlyReviewHistory({ selectionType: 'dropdown' }));
        break;
      case '상품 문의':
        void amplitudeService.logEvent(new SelectMyKurlyProductInquiryHistory({ selectionType: 'dropdown' }));
        break;
      case '적립금':
        void amplitudeService.logEvent(new SelectMyKurlyPointHistory({ selectionType: 'dropdown' }));
        break;
      case '쿠폰':
        void amplitudeService.logEvent(new SelectMyKurlyCouponList({ selectionType: 'dropdown' }));
        break;
      case '나의 컬리 스타일':
        void amplitudeService.logEvent(new SelectMyKurlyStyle({ selectionType: 'dropdown' }));
        break;
      case '공지사항':
        void amplitudeService.logEvent(new SelectMyKurlyNoticeList());
        break;
      case '자주하는 질문':
        void amplitudeService.logEvent(new SelectMyKurlyFrequentlyQna());
        break;
      case '1:1 문의':
        void amplitudeService.logEvent(new SelectMyKurlyPersonalInquiryHistory());
        break;
      case '대량주문 문의':
        void amplitudeService.logEvent(new SelectMyKurlyBulkOrder());
        break;
      default:
        break;
    }
  }, []);

  return (
    <Container className={className}>
      {menus.map(({ title, link, hasNew }) => (
        <Link key={title} href={link}>
          <LinkItem onClick={() => handleSubMenuLink(title)}>
            {title}
            {hasNew && (
              <>
                {' '}
                <NewIcon data-testid="new-icon" />
              </>
            )}
          </LinkItem>
        </Link>
      ))}
    </Container>
  );
}

export default memo(SubMenu);
